module.exports = __webpack_public_path__ + "static/media/Temperature_mode_EN.0f2d4d1e.pdf";